import api from "@/api";
import { mapMutations } from "vuex";
import md5 from 'js-md5';
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  name: "LoginPage",
  data() {
    return {
      loginModel: {
        account: null,
        password: null
      },
      passwordError: null,
      accountError: null,
      loginVisible: false,
      iamId: null,
      stop: this.$route.query.stop,
      ap: this.$route.query.ap,
      logoutUrl: 'https://iam.gongshu.gov.cn/idp/authCenter/GLO?entityId=xhzjxt&redirectToLogin=true&redirctToUrl=' + window.location.origin
    };
  },
  methods: {
    ...mapMutations(['updateUser']),
    doLogin() {
      let verify = true;
      if (!this.loginModel.account) {
        this.accountError = '账号必填';
        verify = false;
      }
      if (!this.loginModel.password) {
        this.passwordError = '密码必填';
        verify = false;
      }
      if (!verify) {
        return;
      }
      this.accountError = null;
      this.passwordError = null;
      api.login({
        phone: this.loginModel.account,
        password: md5(this.loginModel.password),
        channel: 0
      }).then(ret => {
        localStorage.setItem('access_token', ret.accessToken);
        this.updateUser(ret);
        if (this.iamId != null) {
          ElMessageBox.confirm('绑定后下次扫码可直接登录', '是否绑定此浙政钉账号?', {
            confirmButtonText: '好的',
            cancelButtonText: '下次吧',
            type: 'warning'
          }).then(() => {
            api.bindIamByToken(this.iamId).finally(() => {
              this.goNext(ret.index);
            });
          }).catch(() => {
            this.goNext(ret.index);
          });
        } else {
          this.goNext(ret.index);
        }
      }).catch(err => {
        console.log('login err', err);
      });
    },
    goNext(page) {
      // 取到原页面路径
      let url = this.$route.query.redirect;
      // 跳转回原页面
      this.$router.replace(url ? url : page);
    },
    init() {
      if (this.$route.query.stop != null) {
        if (this.ap != null) {
          this.loginVisible = true;
        }
        return;
      }
      if (this.$route.query.code) {
        api.getUserInfoByCode(this.$route.query.code).then(ret => {
          if (ret.action == 0) {
            //未绑定
            this.iamId = ret.token;
            this.loginVisible = true;
            ElMessage.error('未绑定账号，请使用账号密码登录');
          } else {
            localStorage.setItem('access_token', ret.accessToken);
            this.goNext(ret.index);
          }
        });
      } else {
        let url = this.$route.query.redirect;
        api.getGongshuLoginRedirect(url).then(ret => {
          window.location.href = ret;
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};